/**
 * iter-170c — Extracted from AdvisorChat.jsx to lower cyclomatic
 * complexity of ActionButton (CC 39 → ~10).
 *
 * Exports the editable-field schema per action ``type`` plus the small
 * coercion helper used by ActionField inputs. Pure config + pure
 * functions, no React imports — easy to unit test.
 */

/** Field schema per action type. Each entry: [key, label_en/es, html_input_type]. */
export const FIELDS_BY_TYPE = {
  goal: (t) => [
    ["name", t("Name", "Nombre"), "text"],
    ["target_amount", t("Target amount", "Monto objetivo"), "number"],
    ["target_date", t("Target date", "Fecha objetivo"), "date"],
    ["currency", "Currency", "text"],
  ],
  debt: (t) => [
    ["name", t("Name", "Nombre"), "text"],
    ["balance", t("Balance", "Saldo"), "number"],
    ["interest_rate", "APR %", "number"],
    ["monthly_payment", t("Monthly payment", "Cuota mensual"), "number"],
    ["currency", "Currency", "text"],
  ],
  investment: (t) => [
    ["name", t("Name", "Nombre"), "text"],
    ["amount_invested", t("Amount invested", "Monto invertido"), "number"],
    ["expected_annual_return", "% anual", "number"],
    ["withdrawal_date", t("Exit date", "Fecha de salida"), "date"],
    ["currency", "Currency", "text"],
  ],
  receivable: (t) => [
    ["client_name", t("Client", "Cliente"), "text"],
    ["amount", t("Amount", "Monto"), "number"],
    ["expected_date", t("Expected date", "Fecha esperada"), "date"],
    ["currency", "Currency", "text"],
  ],
  payment: (t) => [
    ["concept", t("Concept", "Concepto"), "text"],
    ["amount", t("Amount", "Monto"), "number"],
    ["due_date", t("Due date", "Vencimiento"), "date"],
    ["currency", "Currency", "text"],
  ],
};

/** Coerce the raw input string to the type's native JS value. */
export function coerceFieldValue(type, raw) {
  if (type === "number") return raw === "" ? "" : Number(raw);
  return raw;
}

/** Resolve the field list for an action's ``type``; empty array if unknown. */
export function fieldsForActionType(type, t) {
  const factory = FIELDS_BY_TYPE[type];
  return factory ? factory(t) : [];
}

/** Build the human label for a suggested action header. */
export function actionLabel(action) {
  if (action.label) return action.label;
  const kind = action.type || "action";
  return action.name ? `${kind}: ${action.name}` : kind;
}
